import { render, staticRenderFns } from "./HistoryModal.vue?vue&type=template&id=531d8bcd&scoped=true"
import script from "./HistoryModal.vue?vue&type=script&lang=js"
export * from "./HistoryModal.vue?vue&type=script&lang=js"
import style0 from "./HistoryModal.vue?vue&type=style&index=0&id=531d8bcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531d8bcd",
  null
  
)

export default component.exports